import React, { useEffect, useState } from 'react';
import Transaction from './Transaction';
import { FeedUI } from './types';
import TransactionListFooter from './TransactionListFooter';
import { getFeed } from '../api/tjtApi';
import pulseClient from '../pulse-tracking';

const TransactionFeed = () => {
    const [uiData, setUiData] = useState<FeedUI | null>(null);

    const shouldShowFeed = !!uiData?.transactions[0];

    const fetchFeedData = async (signal: AbortSignal) => {
        const sections = await getFeed(signal);
        if (sections) setUiData(sections);
    };

    // Initial data fetch
    useEffect(() => {
        const controller = new AbortController();
        fetchFeedData(controller.signal);

        return () => {
            controller.abort();
        };
    }, []);

    // Tracking with pulse if any content is visible
    useEffect(() => {
        if (shouldShowFeed) {
            pulseClient.trackFeedView();
        }
    }, [shouldShowFeed]);

    // For fetch errors or when user has no transactions in their feed
    if (!uiData || !shouldShowFeed) {
        return null;
    }

    return (
        <section
            aria-labelledby="tjt-transaction-heading"
            className="tjt-transaction-feed mt-12"
        >
            <h2
                id="tjt-transaction-heading"
                className="h4 mb-12 hidden lg:block"
            >
                {uiData.head.title}
            </h2>

            {/* We might render a list here in the future */}
            <Transaction transaction={uiData.transactions[0]} />

            <TransactionListFooter />
        </section>
    );
};

export default TransactionFeed;
